import { render, staticRenderFns } from "./RegStep1.vue?vue&type=template&id=1af56b0a&scoped=true"
import script from "./RegStep1.vue?vue&type=script&lang=js"
export * from "./RegStep1.vue?vue&type=script&lang=js"
import style0 from "./RegStep1.vue?vue&type=style&index=0&id=1af56b0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af56b0a",
  null
  
)

export default component.exports